import {
  draggable,
  dropTargetForElements,
  monitorForElements,
} from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { combine } from '@atlaskit/pragmatic-drag-and-drop/combine';
import { reorder } from '@atlaskit/pragmatic-drag-and-drop/reorder';
import { attachClosestEdge, extractClosestEdge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';
import { getReorderDestinationIndex } from '@atlaskit/pragmatic-drag-and-drop-hitbox/util/get-reorder-destination-index';
import { reorderWithEdge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/util/reorder-with-edge';

declare global {
  interface Window {
    GZPragmaticDnd?: Record<string, unknown>;
  }
}

const api = {
  draggable,
  dropTargetForElements,
  monitorForElements,
  combine,
  reorder,
  attachClosestEdge,
  extractClosestEdge,
  getReorderDestinationIndex,
  reorderWithEdge,
};

window.GZPragmaticDnd = api;

console.info('[pragmatic-dnd-bundle] ready', {
  draggable: typeof draggable === 'function',
  dropTargetForElements: typeof dropTargetForElements === 'function',
  monitorForElements: typeof monitorForElements === 'function',
  getReorderDestinationIndex: typeof getReorderDestinationIndex === 'function',
});

window.dispatchEvent(
  new CustomEvent('pragmatic-dnd-ready', {
    detail: { loaded: true },
  }),
);
